import { useMemo } from 'react';
import { theme } from '@fiverr-private/theme';

export const useIsLessThanSmScreen = () =>
    useMemo(() => typeof window !== 'undefined' && window.innerWidth < theme.numericBreakpoints.sm, []);
